module.exports = __webpack_public_path__ + "media/images/icons/telegram-483aa97484c690475388661595943622.svg";